import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/styles';

export default ({ spacing }: Theme) =>
  createStyles({
    title: {
      fontSize: '1.25rem',
      marginBottom: spacing(1),
      color: 'inherit',
    },
    list: {
      padding: 0,
    },
  });
